import { Paper } from '@material-ui/core'
import React from 'react'
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';

function CustomPagination(props) {
    const {
        onChangePagination = () => { },
        filters = {},
        totalPage = "",
        apiName = "vessel"
    } = props

    const offset = Number(filters.offset) || 1;
    const limit = Number(filters.limit) || 50;

    const totalItems = Number(totalPage) || 0;
    const totalPages = Number(filters.totalPages) || (totalItems > 0 ? Math.ceil(totalItems / limit) : 1);

    const isFirstPage = offset <= 1;
    const isLastPage = offset >= totalPages || (totalItems > 0 && offset * limit >= totalItems);

    const startItem = totalItems > 0 ? ((offset - 1) * limit) + 1 : (totalItems === 0 ? 0 : 1);
    const endItem = Math.min(offset * limit, totalItems || (offset * limit));

    const vesselShowing = (
        <p className="text-[12px] font-medium text-slate-600 mb-0">
            Showing <span>{startItem}</span>-<span>{endItem}</span> of <span>{totalItems || 0}</span>
        </p>
    );

    return (
        <div className="pagination-button-div">
            {vesselShowing}
            <Paper
                elevation={0}
                className={isFirstPage ? "disabled" : ""}
                onClick={() => !isFirstPage && onChangePagination('dec', apiName)}
                style={{
                    opacity: isFirstPage ? 0.35 : 1,
                    cursor: isFirstPage ? 'not-allowed' : 'pointer',
                    pointerEvents: isFirstPage ? 'none' : 'auto',
                }}
            >
                <MdNavigateBefore size={18} />
            </Paper>
            <Paper
                elevation={0}
                className={isLastPage ? "disabled" : ""}
                onClick={() => !isLastPage && onChangePagination('inc', apiName)}
                style={{
                    opacity: isLastPage ? 0.35 : 1,
                    cursor: isLastPage ? 'not-allowed' : 'pointer',
                    pointerEvents: isLastPage ? 'none' : 'auto',
                }}
            >
                <MdNavigateNext size={18} />
            </Paper>
        </div>
    );
}

export default CustomPagination;
